import { render, staticRenderFns } from "./NewArrivalAll.vue?vue&type=template&id=574c09bd&scoped=true&"
import script from "./NewArrivalAll.vue?vue&type=script&lang=js&"
export * from "./NewArrivalAll.vue?vue&type=script&lang=js&"
import style0 from "./NewArrivalAll.vue?vue&type=style&index=0&id=574c09bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574c09bd",
  null
  
)

export default component.exports